import { render, staticRenderFns } from "./MailTemplatePropSelect.vue?vue&type=template&id=2ebfb5d5"
import script from "./MailTemplatePropSelect.vue?vue&type=script&lang=ts"
export * from "./MailTemplatePropSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ebfb5d5')) {
      api.createRecord('2ebfb5d5', component.options)
    } else {
      api.reload('2ebfb5d5', component.options)
    }
    module.hot.accept("./MailTemplatePropSelect.vue?vue&type=template&id=2ebfb5d5", function () {
      api.rerender('2ebfb5d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail-template-editor/MailTemplatePropSelect.vue"
export default component.exports